export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    }
  }
  return targetObj
}


export function  isShouldReload(router,contrastPath) {
  let currentPage = router;
  if(currentPage !== '/') {
    let findPath = currentPage.split('/')[1];
    if(contrastPath){
      let findPage = contrastPath.indexOf(findPath)
      if(findPage !== -1) {
        return false
      }else {
        return true
      }
    } else {
      return true
    }
  }else {
    return true
  }

}

// 判断对象是否为空
export function objIsEmpty(obj) {
  return Object.keys(obj).length === 0
}
// 判断是否存在一个属性
export function isExistField(arg) {
  if(arg !== undefined && arg !== null && arg !== '') {
    return true
  } else {
    return false
  }
}

//清空数组中没有值得数据
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

//数组去重
export function uniqueArr(arr) {
  return Array.from ? Array.from(new Set(arr)) : [].slice.call(new Set(arr))
}

//判断数组里是否有某个值
export const contains = (() =>
    Array.prototype.includes
      ? (arr, value) => arr.includes(value)
      : (arr, value) => arr.some(el => el === value)
);

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString = className
  } else {
    /* classString =
       classString.substr(0, nameIndex) +
       classString.substr(nameIndex + className.length);*/
  }
  element.className = classString
}

//价格格式转换
export function numberFormat(number, decimals, dec_point, thousands_sep, roundtag) {
  /*
  * 参数说明：
  * number：要格式化的数字
  * decimals：保留几位小数
  * dec_point：小数点符号
  * thousands_sep：千分位符号
  * roundtag:舍入参数，默认 floor  "ceil" 向上取,"floor"向下取,"round" 四舍五入
  * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  roundtag = roundtag || "floor"; //"ceil","floor","round"
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      console.log();
      return '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k;
    };
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

/**
 * @Description: 生成随机数
 * @param minNum 最小数值
 * @param maxNum 最大数值
 */
export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
      break;
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      break;
    default:
      return 0;
      break;
  }
}

export function changePhone(phone) {
  let str2 = '';
  if (phone) {
    let str = JSON.stringify(JSON.parse(phone));
    str2 = str.substr(0, 3) + '****' + str.substr(7);//转化成123*****55555
  }
  return str2;
}

//节流
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * 时间戳转换
 * @param inputTime
 * @param format  'yyyy-mm-dd'
 */
export function timeStampToDate(inputTime, format) {
  if (!inputTime) {
    return ''
  }
  let date = new Date(inputTime);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  if (format == 'yyyy-mm-dd') {
    return y + '-' + m + '-' + d;
  }
  if (format == 'yyyy-mm') {
    return y + '-' + m ;
  }
  if (format == 'hh-mm') {
    return h + ':' + minute;
  }
  if (format == 'hh:mm:ss') {
    return h + ':' + minute + ':' + second;
  }
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

//经纬度转换成三角函数中度分表形式。
function Rad(d) {
  return (d * Math.PI / 180.0);
}

//计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function getDistance(lat1, lng1, lat2, lng2) {
  let radLat1 = Rad(lat1);
  let radLat2 = Rad(lat2);
  let a = radLat1 - radLat2;
  let b = Rad(lng1) - Rad(lng2);
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137;// EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000; //输出为公里
  //s=s.toFixed(4);
  return s;
}

export function formatDateTime(value, format) {
  if (!value) {
    return ''
  }
  let date = new Date(value);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let scored = date.getSeconds();

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  scored = scored < 10 ? "0" + scored : scored;
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;

  if (format === 'yyyy-mm-dd') {
    return year + "-" + month + "-" + day
  }
  if (format === 'yyyy-mm-dd hh:mm:ss') {
    return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + scored;
  }

  if (format === 'yyyy-mm-dd hh:mm') {
    return year + "-" + month + "-" + day + " " + hours + ":" + minutes
  }
  if (format === 'hh:mm:ss') {
    return   " " + hours + ":" + minutes+":" + scored;
  }
  return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + scored;
}


// 根据时间获取星期
export function weekDayFormat(str) {
  if (str) {
    let weekDay = new Date(str).getDay();
    if (weekDay === 1) {
      return "星期一";
    } else if (weekDay === 2) {
      return "星期二";
    } else if (weekDay === 3) {
      return "星期三";
    } else if (weekDay === 4) {
      return "星期四";
    } else if (weekDay === 5) {
      return "星期五";
    } else if (weekDay === 6) {
      return "星期六";
    } else if (weekDay === 0) {
      return "星期天";
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js